export default function trackQMAction(eventCode, data = {}) {
  window?.QuantumMetricAPI?.sendEvent(eventCode, 0, data);
}
